import React, { useEffect } from 'react'

function RenderLinks() {
    useEffect(()=>{
        const script1 = document.createElement('script');
        script1.src = 'static/js/main.js';
        script1.async = true;
        document.getElementsByClassName('wrapper')[0].appendChild(script1)
        return ()=>{
          if(script1.parentNode === document.getElementsByClassName('wrapper')[0])
            document.getElementsByClassName('wrapper')[0].removeChild(script1)
        }
      },[])

  return (
    <div>
      
    </div>
  )
}

export default RenderLinks
